export const AgentLineAgent2 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 18.8368C7.63862 20.0913 5.58355 20.3775 4.58693 19.3809C3.32084 18.1148 4.12505 15.1404 6.35467 12C7.07751 10.9819 7.95017 9.94629 8.95067 8.94578C9.39646 8.49999 9.84922 8.07958 10.3043 7.68649C10.8689 7.19877 11.4371 6.75313 12 6.35325C12.5953 5.93033 13.1847 5.55861 13.7577 5.24249C14.19 5.00397 14.6129 4.7971 15.022 4.62378C16.9323 3.81435 18.5401 3.73639 19.3857 4.58204C21.0623 6.25856 19.1086 10.9305 15.022 15.0171C14.679 15.3601 14.332 15.688 13.9829 16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.81783 5C7.55895 3.85344 5.60979 3.61973 4.64747 4.58204C2.97093 6.25856 4.92464 10.9305 9.0112 15.0171C13.0978 19.1037 17.7697 21.0574 19.4463 19.3809C21.1228 17.7043 19.1691 13.0324 15.0825 8.94578C14.6591 8.52239 14.2295 8.12189 13.7975 7.74595"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.8304 9.1677C11.8751 8.99182 12.1249 8.99182 12.1696 9.1677L12.4527 10.282C12.6106 10.9038 13.0962 11.3894 13.718 11.5473L14.8323 11.8304C15.0082 11.8751 15.0082 12.1249 14.8323 12.1696L13.718 12.4527C13.0962 12.6106 12.6106 13.0962 12.4527 13.718L12.1696 14.8323C12.1249 15.0082 11.8751 15.0082 11.8304 14.8323L11.5473 13.718C11.3894 13.0962 10.9038 12.6106 10.282 12.4527L9.1677 12.1696C8.99182 12.1249 8.99182 11.8751 9.1677 11.8304L10.282 11.5473C10.9038 11.3894 11.3894 10.9038 11.5473 10.282L11.8304 9.1677Z"
      fill="currentColor"
    />
  </svg>
);
